import React, { useCallback, useMemo, useState } from 'react';
import styles from './UnitProgram.module.scss';
import ProgramItem from './card/ProgramItem';
import { Program } from '../../types';
import { useAnalytics, Events, useUser } from '@hooks';
import NavLayout from './navLayout/NavLayout';

type Props = {
  courses: Program[] | undefined;
  showEdit?: boolean;
  isParentApp?: boolean;
  handleDuplicateCourse?: (program: Program) => void
  specialCourseId?: string;
  refresh?: () => void;
  isPrimary?: boolean;
};

function UnitProgram(props: Props) {
  const { courses, showEdit, isParentApp, specialCourseId, isPrimary=true } = props;
  const [selected, setSelected] = useState(false);
  const [hoveredUnitId, setHoveredUnitId] = useState("");
  const [cardHovered, setCardHovered] = useState(false);
  const [centerCard, setCenterCard] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [user] = useUser();
  const { trackEvent } = useAnalytics();
  const [loadOthers, setLoadOthers] = useState<number | null>(null);  

  const handleSelect = useCallback((program: Program) => {
    if (selectedId === program.id) {
      setSelected(false);
      setSelectedId(null);
      trackEvent(Events.actions.courseCollapsed, {
        course_name: program.name,
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    } else {
      setSelected(true);
      setSelectedId(program.id);
      setTimeout(() => {
        const courseElement = document.getElementById(program.id);
        courseElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }, 500)
      trackEvent(Events.actions.courseOpened, {
        course_name: program.name,
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`
      });
    }
  }, [selectedId, setSelected, setSelectedId, trackEvent, user])

  const handleNoneSelect = () => {
    setSelected(false);
    setSelectedId(null);
  }
  const _data = useMemo(() => {
    if (!courses) return [];
    
    const programs = [...courses];
    return programs.sort((a, b) => {
      if (a.favorite && !b.favorite) return -1;
      if (!a.favorite && b.favorite) return 1;
      const aOrder = a.order ?? 1000;
      const bOrder = b.order ?? 1000;
      return aOrder - bOrder;
    });
  }, [courses]);

  const handleUnitHovered = useCallback((unitId: string, hovered: boolean) => {
    setHoveredUnitId(unitId);
    setCardHovered(hovered)
    if (hovered) {
      setTimeout(() => {
        document.getElementById("root")!.style.overflow = "hidden"
      }, 500)
    } else {
      document.getElementById("root")!.style.overflow = "auto"  
    }
  }, [])

  const onCloseInfo = () => {
    setHoveredUnitId('')
    setCardHovered(false)
    document.getElementById("root")!.style.overflow = "auto"
    const unitPage = document.getElementById("unitsPage")
    if (unitPage) {
      unitPage.style.paddingBottom = '0';
    }
  }

  const handleSelectedCenterCard = useCallback((centerCard: boolean) => {
    setCenterCard(centerCard)
  }, [])

  if (!courses) return null;

  return (
    <div id={'unitsPage'} className={styles.programs}>
      {isPrimary ? <NavLayout programName={"Student Voice Series"} /> : null}
      <div className={styles.listView}>
      {_data.map((item, index) => 
        <div key={index} style={{position: 'relative'}}>
          <ProgramItem showEdit={showEdit} cardHovered={cardHovered} hoveredUnitId={hoveredUnitId} handleSelectedCenterCard={handleSelectedCenterCard}
            program={item} isParentApp={isParentApp} selected={selected} selectedId={selectedId} handleSeleted={handleSelect} 
            handleNoneSelect={handleNoneSelect} specialCourseId={specialCourseId} handleCardHovered={handleUnitHovered} 
            refresh={props.refresh} loadOthers={loadOthers} setLoadOthers={setLoadOthers} index={index}
          /> 
        </div>
      )}
      </div>
      {cardHovered && <div>
        <div className={styles.blurBackground} onClick={onCloseInfo} style={{bottom: centerCard ? -500 : -300}}/>
      </div>}
    </div>
  );
}

export default UnitProgram;
